import { css } from "@emotion/react";
import React, { Suspense, lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { Center } from "../../base";

const Explorer = lazy(() => import("../Explorer"));

const HeaderCenter = () => (
  <Center
    css={css`
      flex: 0 0 auto;
      width: 50%;
    `}
  >
    <Switch>
      <Route path={["/explore/:type/:slug", "/"]}>
        <Suspense>
          <Explorer />
        </Suspense>
      </Route>
    </Switch>
  </Center>
);

export default HeaderCenter;
